<template>
  <div class="main">
    <div
      class="card-header bg-success mx-auto"
      style="color: white; width: 80%"
    >
      PICK-UP INSTRUCTIONS
    </div>
    <div class="card-body">
      <!-- Rust question -->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>1</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="overlay[0] && $v.pickupRustAcknowledgement.required"
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="rust box">
              <h4>
                Please Confirm You Understand All Used Shipping Containers Will
                Have Rust & Dents
                <strong
                  v-if="!$v.pickupRustAcknowledgement.required"
                  style="color: red; font-size: 18px"
                  >*</strong
                >
              </h4>
              <h6>
                {{ rustmessage_1 }}
                <span>
                  <a
                    href="https://westerncontainersales.com/buy-shipping-containers-online/guarantee/"
                    target="_blank"
                    style="color: #6dbe45"
                  >
                    every container we sell is covered by our 1-year warranty.
                  </a>
                </span>
                {{ rustmessage_2 }}
                <span>
                  <a
                    href="https://westerncontainersales.com/sample-pics/"
                    target="_blank"
                    style="color: #6dbe45"
                    >Shipping Container Sample Photos by Condition.</a
                  >
                </span>
              </h6>
              <label for="rust_accept">
                <input
                  type="radio"
                  id="rust_accept"
                  value="Accepted"
                  v-model="bind_RustAcknowledgement"
                  @change="handleUserInputUpdate(0)"
                />
                I Understand that All Used Shipping Containers Have Rust & Dents
              </label>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- Rust question ends -->
      <!-- pickup inspection question -->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>2</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="overlay[1] && $v.pickupInspection.required"
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="pickupinspection box">
              <h4>
                Please Confirm You Will Call the Depot Before Pick-Up to Check
                for Availability and Inspect the Container for Leaks and Holes
                Before Leaving the Depot
                <strong
                  v-if="!$v.pickupInspection.required"
                  style="color: red; font-size: 18px"
                  >*</strong
                >
              </h4>
              <h6>
                {{ pickupinspectionmessage }}
                <span>
                  <a
                    href="https://westerncontainersales.com/buy-shipping-containers-online/guarantee/"
                    target="_blank"
                    style="color: #6dbe45"
                    >Every Container We Sell Comes with Our Guarantee</a
                  >
                </span>
              </h6>
              <label for="inspection_accept">
                <input
                  type="radio"
                  id="inspection_accept"
                  value="I understand"
                  v-model="bind_PickupInspection"
                  @change="handleUserInputUpdate(1)"
                />
                I Confirm that I Will Call the Depot Before Pick-Up and Inspect
                the Container for Leaks and Holes
              </label>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- pickup inspection question ends -->
      <!-- pickup contact details starts-->
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9">
          <v-card
            color="#ffffff"
            class="question_cards"
            style="border-radius: 20px; box-shadow: 1px 2px 2px 3px #6dbe45"
          >
            <div class="question_number">
              <span>3</span>
            </div>
            <v-fade-transition>
              <v-overlay
                :absolute="true"
                :value="overlay[2] && $v.pickupName.required"
              >
                <i
                  class="fa fa-check updateAnimation"
                  style="font-size: 60px; color: green"
                ></i>
              </v-overlay>
            </v-fade-transition>
            <div class="deliverycontact box">
              <h4>
                Please Confirm You Understand The Pick-up Process & Agree to
                <a
                  style="color: #6dbe45"
                  href="https://westerncontainersales.com/about-shipping-containers/terms-conditions/"
                  target="_blank"
                  >&nbsp;Terms & Conditions&nbsp;</a
                >
                of Sale
                <strong
                  v-if="!$v.pickupName.required"
                  style="color: red; font-size: 18px"
                  >*</strong
                >
              </h4>
              <h5>
                Please type your name below to confirm you understand and agree.
              </h5>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="5">
                  <small
                    v-if="!$v.pickupName.required"
                    style="
                      color: #6dbe45;
                      float: left;
                      margin-left: 20px;
                      font-weight: 600;
                    "
                    >Full Name Is Required</small
                  >
                  <br />
                  <v-text-field
                    label="Name"
                    id="PickupName"
                    v-model="bind_PickupName"
                    solo
                    @change="handleUserInputUpdate(2)"
                  >
                    <v-icon slot="prepend" color="#6dbe45">
                      mdi-account
                    </v-icon></v-text-field
                  >
                </v-col>
              </v-row>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <!-- pickup contact details ends-->
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  name: "PickupInstructions",
  data() {
    return {
      rustmessage_1:
        "By clicking the box below, customer verifies that they understand all used shipping containers will have rust and dents. Containers are all guaranteed to be structurally sound, and",
      rustmessage_2:
        "For more information on what to expect, please check out the sample photos on our website:",
      rustmessage_3:
        "(NOTE: customers who purchased a One Trip container should still click the box, as One Trip containers do have a few dents, usually)",
      pickupinspectionmessage:
        "By clicking the box below, customer verifies that they will call ahead to ensure container availability and inspect the container prior to leaving the intermodal depot. Containers can be rejected if they are not structurally sound (doors that seal, floors free of holes, no leaks in roof, etc.), but cannot be rejected due to appearance (all used containers will have rust and dents). The best way to check for leaks is to close the container door behind you and check for light peaking in where it shouldn't be. Please Note: all customer pick-up containers must be returned to the depot for warranty work to be completed. Learn more about our warranty, here: ",
      pickupquestionmessage:
        "Upon arrival at the depot, you'll provide the release number that we will send to you by email. The lift operator will bring you the next container off the stack that matches your purchase criteria. If you have any other questions about how the process works, please ask them below.",
      pickupinstructionsmessage:
        "If you have any questions regarding the pick-up process, please enter them here (if none, please leave blank):",
      overlay: [false, false, false],
    };
  },
  computed: {
    ...mapGetters({
      prepickup: types.PREPICKUPANSWERS,
      pickupName: types.PICKUP_NAME,
      pickupRustAcknowledgement: types.PICKUP_RUSTACKNOWLEDGE,
      pickupInspection: types.PICKUP_INSPECTION,
    }),
    bind_PickupName: {
      get() {
        return this.pickupName;
      },
      set(value) {
        this.updatePickupName(value);
      },
    },
    bind_RustAcknowledgement: {
      get() {
        return this.pickupRustAcknowledgement;
      },
      set(value) {
        this.updateRustAcknowledge(value);
      },
    },
    bind_PickupInspection: {
      get() {
        return this.pickupInspection;
      },
      set(value) {
        this.updatePickupInspection(value);
      },
    },
  },
  validations: {
    pickupName: {
      required,
    },
    pickupRustAcknowledgement: {
      required,
    },
    pickupInspection: {
      required,
    },
  },
  methods: {
    ...mapActions({
      updatePickupInspection: types.ACTIONS_UPDATE_PICKUP_INSPECTION,
      updatePickupName: types.ACTIONS_UPDATE_PICKUP_NAME,
      updateRustAcknowledge: types.ACTIONS_UPDATE_PICKUP_RUSTACKNOWLEDGE,
    }),
    handleUserInputUpdate(idx) {
      //Check animation will appear for 1 second
      this.$set(this.overlay, idx, true);
      setTimeout(() => {
        this.$set(this.overlay, idx, false);
      }, 800);
      this.maintainSessionStorage();
    },
    maintainSessionStorage() {
      const prepickup = JSON.stringify(this.prepickup);
      sessionStorage.setItem("prepickup", prepickup);
    },
  },
};
</script>

<style scoped>
.question_cards {
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 20px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
}

.question_number {
  background-color: #6dbe45;
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.8);
  height: 70px;
  left: -50px;
  position: absolute;
  top: -50px;
  width: 100px;
  -webkit-transform: rotate(-45deg);
}

.question_number span {
  color: #f5f5f5;
  font-family: sans-serif;
  font-size: 0.8em;
  left: 5px;
  top: 52px;
  position: absolute;
  width: 70px;
}

h5 {
  font-size: 14px;
  font-weight: normal;
}

h4 {
  font-size: 18px;
  font-weight: bold;
}

h6 {
  font-style: italic;
  font-size: 15px;
  margin-bottom: 20px;
}

label {
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}

input[type="radio"] {
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.box {
  color: #00587d;
}

.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

.updateAnimation {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
